import {
  AtlasChatPersistedMessage,
  AtlasChatPersistedSession,
  CreateAtlasChatMessageRequest
} from '@secca/shared/models/atlas/atlas-chat.model';
import { ChatMessage } from '@secca/shared/models/atlas/atlas-chatbot.model';
import { AtlasChatHistorySession } from '@secca/shared/models/atlas/atlas-chat-history.model';

export function mapApiSessionToHistorySession(session: AtlasChatPersistedSession): AtlasChatHistorySession {
  return {
    id: session.id,
    sessionId: session.id || '-',
    createdAt: session.created_at,
    sessionDescription: session.session_description || '',
    overallScore: session.overall_score ?? 0,
    caseLabel: session.case_number || '-',
    caseNumber: session.case_number || '-',
    caseContextModeEnabled: !!session.case_context_mode_enabled,
    messages: getHistoryDialogMessages((session.messages || []).map(message => mapApiMessageToChatMessage(message))),
    isCurrent: session.status === 'CURRENT'
  };
}

export function getHistoryDialogMessages(messages: ChatMessage[]): AtlasChatHistorySession['messages'] {
  return messages.filter((message): message is ChatMessage & { author: 'user' | 'bot' } => message.author !== 'system');
}

export function mapApiMessageToChatMessage(message: AtlasChatPersistedMessage): ChatMessage {
  return {
    id: message.id,
    author: message.author === 'USER' ? 'user' : 'bot',
    text: message.text || '',
    timestamp: normalizeMessageTimestamp(message.timestamp),
    html: message.html || undefined,
    feedbackEnabled: message.feedback_enabled,
    caseContextModeEnabled: !!message.context?.enabled,
    caseContextCaseNumber: !!message.context?.case_context_case_number,
    caseContextEnabledFields: message.context?.enabled_fields || [],
    caseContextData: message.context?.data || null,
    reaction: message.reaction === 'LIKE' ? 'like' : message.reaction === 'DISLIKE' ? 'dislike' : null,
    reactionComment: message.reaction_comment || ''
  };
}

export function mapChatMessageToApiRequest(message: ChatMessage): CreateAtlasChatMessageRequest {
  return {
    author: message.author === 'user' ? 'USER' : 'ASSISTANT',
    text: message.text || '',
    html: message.html || null,
    timestamp: message.timestamp || new Date().toISOString(),
    context: {
      enabled: !!message.caseContextModeEnabled,
      enabled_fields: message.caseContextEnabledFields || [],
      case_context_case_number: !!message.caseContextCaseNumber,
      data: message.caseContextData || null
    },
    feedback_enabled: message.feedbackEnabled !== false,
    reaction: message.reaction === 'like' ? 'LIKE' : message.reaction === 'dislike' ? 'DISLIKE' : null,
    reaction_comment: message.reactionComment || null
  };
}

export function normalizeMessageTimestamp(value: string | null | undefined): string | undefined {
  if (!value) {
    return undefined;
  }

  const parsed = new Date(value);
  return isNaN(parsed.getTime()) ? undefined : parsed.toISOString();
}
